export const SELECTORS = {
  PRODUCT_CARD: 'js-above-the-fold-product-card',
  PRODUCT_SWITCHER: 'js-above-the-fold-product-switcher',
  VARIANT_SWITCHER: 'js-above-the-fold-variant-switcher',
  CARD_VARIANT_SWITCHER: 'js-above-the-fold-card-variant-switcher',
  FLAVOR_SWITCHER: 'js-above-the-fold-flavor-switcher',
  FLAVOR_FILTER: 'js-above-the-fold-flavor-filter',
  SUBSCRIPTION_OFFER_MODAL: 'js-above-the-fold-subscription-offer-modal'
};

export const SECTION_SELECTORS = {
  ABOVE_THE_FOLD: 'js-above-the-fold',
  ABOVE_THE_FOLD_TEMPLATE: 'js-above-the-fold-template',

  ABOVE_THE_FOLD_GALLERY: 'js-above-the-fold-gallery',
  ABOVE_THE_FOLD_GALLERY_TEMPLATE: 'js-above-the-fold-gallery-template',

  PRODUCT_PURCHASE_BAR: 'js-product-purchase-bar',
  PRODUCT_PURCHASE_BAR_TEMPLATE: 'js-product-purchase-bar-template',

  FAQ: 'js-faq',
  FAQ_TEMPLATE: 'js-faq-template',

  LIMITED_REWARDS: 'js-above-the-fold-subscription-limited-rewards',
  LIMITED_REWARDS_TEMPLATE: 'js-above-the-fold-subscription-limited-rewards-template'
};

export const CARD_VARIANT_SWITCHER_SELECTORS = {
  ITEM: 'js-card-variant-switcher-item',
  FREE_SHIPPING: 'js-card-variant-switcher-free-shipping',
  SUBSCRIBE_BUTTON: 'js-card-variant-switcher-subscribe'
};

export const FREQUENCY_SWITCHER_SELECTORS = {
  CONTAINER: 'js-frequency-switcher',
  FREE_SHIPPING: 'js-frequency-switcher-free-shipping',

  BASE_PRICE: 'js-base-price-value',

  SUBSCRIPTION_PRICE: 'js-subscription-price-value',
  SUBSCRIPTION_SERVING_PRICE: 'js-subscription-serving-price'
};
